import chuck from './chuck';
import mandi from './mandi';

import getFuncByMode from '../../../../../../../../utils/getFuncByMode';

export default getFuncByMode({
  chuck,
  mandi,
});
